export default {"src":"/login-app/[GIT_HASH]/_next/static/media/owner.4a5fa683.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};